
import ccApp from './cc-webapp/navigator.js'
import UTILS from './utils.js'
import LOGIN2 from './cc-webapp/login2.js'
import { Encrypt } from './aes.js'
import { encrypt } from './des/DES3.js'
import { SERVER,initEnv } from "../api/apiConfig";
import Vue from 'vue'

const targetL = {
  //跳轉地址配置
  column: {
    path: "detail",
    params: [{
      name: "articleId",
      label: "id"
    }] //跳轉所需參數
  },
  video: {
    path: "videoDetail",
    params: [{
      name: "articleId",
      label: "id"
    }]
  },
  audio: {
    path: "audioDetail",
    params: [{
      name: "articleId",
      label: "id"
    }]
  },
  ebook: {
    path: "ebookGuide",
    params: [{
      name: "articleId",
      label: "id"
    }]
  },
  paper: {

  }
};

// var item = {
//     columnCode:"",//audio,ebook
//     relObjectType:"",//media,medialist
//     relObjectId:"",//mediaId
//     objectId:"",//columnId
// }

function openToDetail(item) {
  let types = item.columnCode;
  let target;
  if (item.relObjectType == "medialist") {
    target = targetL["column"];
  } else {
    target = targetL[types];
  }
  // target = targetL["column"];
  console.log(target);
  if (target == undefined) {
    //未配置的目標地址
    return;
  }
  let q = {
    id: item.relObjectId,
    columnId: item.objectId,
    mode: "column"
  };
  let obj = {};
  obj["path"] = target.path;
  obj["query"] = q;
  // obj["query"]["blockTitle"] = this.title;
  // console.log( "gotoTarget2",JSON.stringify(q),JSON.stringify(item));
  //跳轉音頻詳情頁需要提前判斷是否登錄
  var openNewWindows = true;
  console.log("openNewWindows", JSON.stringify(obj))
  if (types == "audio") {
    if (openNewWindows) {
      //新窗口打開
      obj.router = this.$router;
      obj.path = UTILS.splitUrl(obj.path);
      obj.isTransWindows = true;
      ccApp.openTo(obj);
    } else {
      //當前窗口打開
      ccApp.navigateTo(this.$router, obj);
    }
    // });
  } else if (types == "ebook") {
    //新窗口打開,不全屏
    obj.router = this.$router;
    obj.path = UTILS.splitUrl(obj.path);
    // obj.isTransWindows = true;
    ccApp.openTo(obj);
  } else if (types == "paper") {
    var umengObj = {};
    umengObj["page"] = "超越網";
    UTILS.umengReport("interview", umengObj);
    obj["path"] = item.relObjectId;
    if (item.relObjectId.indexOf("superbookcity") > 0) {
      //超越網地址
      obj["toastTip"] = this.$t("RELBOOK_LANG.showToast");
    } else if (item.relObjectId.indexOf("mybookone") > 0) {
      //一本
      obj["toastTip"] = this.$t("RELBOOK_LANG.showToast1");
    } else {
      obj["toastTip"] = this.$t("RELBOOK_LANG.showToast2");
    }
    ccApp.openTo(obj);
  } else {
    if (openNewWindows) {
      //新窗口打開
      obj.router = this.$router;
      obj.path = UTILS.splitUrl(obj.path);
      obj.isTransWindows = true;
      ccApp.openTo(obj);
    } else {
      //當前窗口打開
      ccApp.navigateTo(this.$router, obj);
    }
  }
}

function goPage(url) {
  let obj = {
    router: this.$router,
    path: UTILS.splitUrl(url),
    // path: e,
  };
  ccApp.openTo(obj);
  // this.GLOBAL_.ccApp.navigateTo(this.$router,obj)
}

function openReader(id) {
  // var data = localStorage.getItem('app_session')
  // var sign=""
  // if(data){
  //   data = JSON.parse(data)
  //   let user = {
  //     session:data.session,
  //     userId:data.userId,
  //   }
  //   if(data.userInfo){
  //     user.userInfo = {
  //       nickname:data.userInfo.nickname
  //     }
  //   }
  //   // sign = Encrypt(JSON.stringify(user),process.env.aesKey,process.env.ivKey)
  //   // sign = encrypt(JSON.stringify(user))
  //   sign = JSON.stringify(user)
  // }
  let readerHost = SERVER.READER_URL + "/reader";
  // let readerHost = window.location.href.split("index.htm")[0] + "reader.html#/reader";
  let readerUrl = readerHost + "?mediaId=" + id + '&appid=' + SERVER.APPID + '&dev=' + SERVER.API_DEV + '&console=false'
  // let readerUrl = readerHost + "?mediaId=" + id +'&appid='+SERVER.APPID +'&dev='+SERVER.API_DEV+'&console='+SERVER.CONSOLE+'&sign='+sign
  window.location.href = readerUrl
  console.log("openReader", readerUrl);
}

function goBuyPage(router, id, objType) {
  let buyPage = '/buy'
  if (SERVER.APPID == 'mylink') {
    var data = localStorage.getItem('app_session')
    var sign = ""
    if (data) {
      data = JSON.parse(data)
      let user = {
        session: data.session,
        expireAt: data.expireAt,
        userId: data.userId,
      }
      // if(data.userInfo){
      //   user.userInfo = {
      //     nickname:data.userInfo.nickname
      //   }
      // }
      sign = Encrypt(JSON.stringify(user), process.env.aesPayKey, process.env.ivPayKey)
    }
    let buyUrl = 'openurl-extern-silent://' + SERVER.HOST_PAGE_URL + buyPage + "?id=" + id
      + '&objType=' + objType
      + '&appid=' + SERVER.APPID
      + '&thirdPartToken=' + LOGIN2.getThirdPartToken()
      + '&zSign=' + sign
    window.location.href = buyUrl
    // window.open(buyUrl, '_blank');
    // console.log("openbuyUrl",buyUrl);
  } else {
    router.push({
      path: buyPage,
      query: {
        id: id,
        objType: objType,
      }
    })
  }
}
//从第三方跳转至项目购买页
function goPageByThird(page, obj) {
  let url = SERVER.HOST_PAGE_URL + '/' + page + '?appid=' + SERVER.APPID;
  let params = '';
  if (page == 'buy' && obj) {
    var data = localStorage.getItem('app_session')
    var sign = ""
    if (data) {
      data = JSON.parse(data)
      let user = {
        session: data.session,
        expireAt: data.expireAt,
        userId: data.userId,
      }
      sign = Encrypt(JSON.stringify(user), process.env.aesPayKey, process.env.ivPayKey)
    }
    params = '&objType=' + obj.objType 
      + '&id=' + obj.id 
      + '&retry=' + (obj.retry || 0)
      + '&thirdPartToken=' + LOGIN2.getThirdPartToken()
      + '&zSign=' + sign

  }
  console.log("goPageByThird",url + params);
  window.location.href = url + params;
}

function getUrlKey(name, url) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

function saveIndexQueryParams(url) {
  let appid = getUrlKey('appid', url) || getUrlKey('appId', url) || localStorage.getItem('appId') || 'h5'
  let thirdPartToken = getUrlKey('thirdPartyToken', url)
  // 这是由后台分配的APPID识别号，接口调用都需要用到
  console.log('app saveIndexQueryParams *******', appid, thirdPartToken)

  if (thirdPartToken!=undefined && thirdPartToken != null && thirdPartToken!='undefined') {
    // localStorage.clear();
    LOGIN2.setThirdPartToken(thirdPartToken)
  } else {
    //正常H5渠道也需要用户信息，所以不能移除
    // localStorage.removeItem('app_session');
    // LOGIN2.setThirdPartToken('');
  }
  if (appid) {
    localStorage.setItem('appId', appid);
    //这里this执行vue文件
    Vue.prototype.SERVER.APPID = appid
  }
  // let isDev = getUrlKey('dev', url)
  // Vue.prototype.SERVER.API_DEV = isDev == "true" || false;
  // initEnv();
}

export default {
  openToDetail,
  goPage,
  openReader,
  goBuyPage,
  saveIndexQueryParams,
  goPageByThird,
}



// WEBPACK FOOTER //
// ./src/utils/routerHelper.js